<template>
  <my-container style="border: 1px solid #fc7569; justify-content: space-evenly;">
    <span>공유하기</span>
    <v-divider vertical inset></v-divider>
    <v-btn
      v-for="(button, index) in shareButtons"
      :key="'share' + index"
      icon
      :height="shareButtonSize"
      :width="shareButtonSize"
      @click="share(button.type)"
    >
      <v-img contain :src="button.src" :height="shareButtonSize"></v-img>
    </v-btn>
  </my-container>
</template>

<script>
import MyContainer from "./MyContainer";

export default {
  components: { MyContainer },
  data: () => ({
    shareButtons: [
      { src: require("../assets/share_blog.svg"), type: "blog" },
      { src: require("../assets/share_kakao.svg"), type: "kakao" },
      { src: require("../assets/share_facebook.svg"), type: "facebook" },
      { src: require("../assets/share_twitter.svg"), type: "twitter" },
      { src: require("../assets/share_url.svg"), type: "url" }
    ]
  }),
  computed: {
    url() {
      return window.location.href;
    },
    shareButtonSize() {
      return this.$vuetify.breakpoint.smAndDown ? "24" : "40";
    }
  },
  methods: {
    share(type) {
      this.$amplitude
        .getInstance()
        .logEvent("Button Share Clicked", { type, url: this.url });
      switch (type) {
        case "blog":
          window.open(
            `https://share.naver.com/web/shareView.nhn?url=${this.url}&title=중국어 잠재력 테스트`
          );
          break;
        case "kakao":
          this.sendCustom(this.$route.query.score);
          break;
        case "facebook":
          window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${this.url}&t=중국어 잠재력 테스트`
          );
          break;
        case "twitter":
          window.open(
            `https://twitter.com/intent/tweet?url=${this.url}&text=중국어 잠재력 테스트`
          );
          break;
        case "url":
          this.$copyText(this.url).then(() => {
            alert("URL이 복사되었습니다.");
          });
          break;
        default:
          break;
      }
    },
    sendCustom(score) {
      const options = { templateArgs: { path: this.$route.fullPath } };
      switch (score) {
        case "10":
        case "9":
          options.templateId = 24894;
          break;
        case "8":
        case "7":
        case "6":
          options.templateId = 24895;
          break;
        case "5":
        case "4":
        case "3":
          options.templateId = 24896;
          break;
        case "2":
        case "1":
        case "0":
          options.templateId = 24897;
          break;
        default:
          options.templateId = 24884;
          break;
      }
      window.Kakao.Link.sendCustom(options);
    }
  }
};
</script>

<style>
</style>
